import React from 'react';
import styled from 'styled-components';
import settingsLeft from '../../../assets/card-apply/icons/settings-left.svg';
import settingsRight from '../../../assets/card-apply/icons/settings-right.svg';
import strokeIcon from '../../../assets/card-apply/icons/stroke.svg';
import zeroDollar from '../../../assets/card-apply/icons/zero-dollar.svg';

// ############################ Styles ############################
// tslint:disable:variable-name

const SCardSummary = styled.ul(({ theme }) => {
  return `
      padding: 48px 65px;
      background-color: ${theme.colors.brightBlue95};
      max-width: 280px;
      display: flex;
      align-items: center;
      flex-direction: column;
      @media only screen and (min-width: 500px) {
        max-width: initial;
        align-items: initial;
      }
  `;
});

const SItem = styled.li(
  ({ theme }) => `
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  &:not(:last-child) {
    margin-bottom: ${theme.spacing.medium}px;
    @media only screen and (min-width: 500px) {
      margin-bottom: ${theme.spacing.large2}px;
    }
  }
  @media only screen and (min-width: 500px) {
    flex-wrap: nowrap;
    align-items: stretch;
  }
`
);

const SIconWrap = styled.div(
  ({ theme }) => `
  min-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: ${theme.spacing.mediumLarger}px;
  height: 100px;
  @media only screen and (min-width: 500px) {
    min-width: 70px;
    max-width: 70px;
    justify-content: flex-start;
  }
`
);

const SIcon = styled.img`
  max-width: 100%;
  max-height: 100%;
  &:first-child {
    margin-top: 10px;
  }
`;

const STextWrap = styled.div`
  display: flex;
  flex-direction: column;
`;

const SText = styled.div(
  ({ theme }) => `
  color: ${theme.colors.deepBlue};
  font-weight: ${theme.font.weight.bold};
  margin-bottom: 8px;
  font-size: ${theme.font.size.smallMedium};
  @media only screen and (min-width: 500px) {
    font-size: ${theme.font.size.medium};
  }
`
);

const STextSmall = styled.div(
  ({ theme }) => `

  color: ${theme.colors.primary};
  font-size: ${theme.font.size.small};
  @media only screen and (min-width: 500px) {
    font-size: ${theme.font.size.smallMedium};
  }
`
);

// tslint:enable:variable-name
// ############################ End Styles ###########################

export interface ICardSummaryProps {
  className?: string;
}

// tslint:disable-next-line:variable-name
const CardSummary: React.FC<ICardSummaryProps> = (props) => (
  <SCardSummary data-at="cardSummary" className={props.className}>
    <SItem data-at="convenience-and-control">
      <SIconWrap>
        <SIcon data-at="icon" src={settingsLeft} alt="Settings Icon1" />
        <SIcon data-at="icon" src={settingsRight} alt="Settings Icon2" />
      </SIconWrap>
      <STextWrap>
        <SText data-at="text">{'Convenience & Control'}</SText>
        <STextSmall data-at="ConvenienceAndControlTextSmall">With the Sunbit app, available for iPhone and Android devices.^</STextSmall>
      </STextWrap>
    </SItem>
    <SItem data-at="spec-no-annual-fee">
      <SIconWrap>
        <SIcon data-at="icon" src={zeroDollar} alt="Zero dollar" />
      </SIconWrap>
      <STextWrap>
        <SText data-at="text">No Fees</SText>
        <STextSmall data-at="textSmall">No application fee, no annual fees, no late fees.</STextSmall>
      </STextWrap>
    </SItem>
    <SItem data-at="spec-cashback">
      <SIconWrap>
        <SIcon data-at="icon" src={strokeIcon} alt="Cashback Icon" />
      </SIconWrap>
      <STextWrap>
        <SText data-at="text">Quick Decision</SText>
        <STextSmall data-at="textSmall">Lightning fast decisions.</STextSmall>
      </STextWrap>
    </SItem>
  </SCardSummary>
);

export default CardSummary;
